import React from 'react';
import { Task, WorkOrder } from '../../types/workOrders';
import { TaskItem } from './TaskItem';

interface TaskListProps {
  tasks: Task[];
  workOrder: WorkOrder;
  onTaskUpdate: () => void;
}

export function TaskList({ tasks, workOrder, onTaskUpdate }: TaskListProps) {
  const visibleTasks = tasks.filter(task => task.isVisible);
  const completedTasks = visibleTasks.filter(task => task.isCompleted);
  const pendingTasks = visibleTasks.filter(task => !task.isCompleted);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
          Tasks
        </h2>
        <div className="flex items-center gap-4">
          <div className="text-sm">
            <span className="text-green-600 dark:text-green-400">{completedTasks.length}</span>
            <span className="text-gray-500 dark:text-gray-400"> / {visibleTasks.length} completed</span>
          </div>
        </div>
      </div>

      {visibleTasks.length === 0 ? (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          No tasks available
        </div>
      ) : (
        <div className="space-y-4">
          {/* Pending Tasks */}
          {pendingTasks.length > 0 && (
            <div className="space-y-4">
              {pendingTasks.map((task, index) => (
                <TaskItem
                  key={task.id}
                  task={task}
                  workOrder={workOrder}
                  onTaskUpdate={onTaskUpdate}
                  isLast={index === pendingTasks.length - 1}
                />
              ))}
            </div>
          )}

          {/* Completed Tasks */}
          {completedTasks.length > 0 && (
            <div className="space-y-4 mt-6">
              <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">
                Completed Tasks
              </h3>
              {completedTasks.map((task, index) => (
                <TaskItem
                  key={task.id}
                  task={task}
                  workOrder={workOrder}
                  onTaskUpdate={onTaskUpdate}
                  isLast={index === completedTasks.length - 1}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}